import { render } from "./SubstituteUsersDataTable.vue?vue&type=template&id=5eaf9db8"
import script from "./SubstituteUsersDataTable.vue?vue&type=script&lang=js"
export * from "./SubstituteUsersDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__